const URL_MAPS = {
  'localhost': {
    'api': 'http://localhost:8020',
    'static': 'http://localhost:8020/storage/',
    'buyer': 'http://localhost:8021',
    'newseller': 'http://localhost:8022',
  },
  'staging-oldseller-siplah.tokoladang.co.id': {
    'api': 'https://staging-api-siplah.tokoladang.co.id',
    'static': 'https://staging-api-siplah.tokoladang.co.id/storage/',
    'buyer': 'https://staging-siplah.tokoladang.co.id',
    'newseller': 'https://staging-seller-siplah.tokoladang.co.id',
  },
  'staging-oldseller.siplahtokoladang.id': {
    'api': 'https://staging-api.siplahtokoladang.id',
    'static': 'https://staging-api.siplahtokoladang.id/storage/',
    'buyer': 'https://staging.siplahtokoladang.id',
    'newseller': 'https://staging.seller.siplahtokoladang.id',
  },
  'oldseller-siplah.tokoladang.co.id': {
    'api': 'https://api-siplah.tokoladang.co.id',
    'static': 'https://siplah-oss.tokoladang.co.id/',
    'buyer': 'https://siplah.tokoladang.co.id',
    'newseller': 'https://seller-siplah.tokoladang.co.id',
  },
  'oldseller.siplahtokoladang.id': {
    'api': 'https://api.siplahtokoladang.id',
    'static': 'https://oss.siplahtokoladang.id/',
    'buyer': 'https://siplahtokoladang.id',
    'newseller': 'https://seller.siplahtokoladang.id',
  },
}

const DEFAULT_HOST = 'seller-siplah.tokoladang.co.id'

let cachedUrlByHost = null

export const getBaseUrl = (type, path = '') => {
  
  // Cache urlByHost to avoid repeated URL parsing and mapping
  if (!cachedUrlByHost) {
    const hostname = window.location.hostname
    cachedUrlByHost = URL_MAPS[hostname] ?? URL_MAPS[DEFAULT_HOST]
  }

  const baseUrl = cachedUrlByHost[type]
  if (!baseUrl) {
    console.warn(`Unknown URL type: ${type}`)
    return path
  }

  return baseUrl + path
}

// Optional: Reset cache for testing or if hostname changes
export const resetUrlByHostCache = () => {
  cachedUrlByHost = null
}
